import {
  combineReducers,
  configureStore,
  StateFromReducersMapObject,
} from "@reduxjs/toolkit";
import { miniAppApi, REDUCER_PATH } from "@shared/api";
import {
  NOTIFICATIONS_SLICE_KEY,
  notificationsSlice,
} from "@features/notifications";
// import { THEME_SLICE_KEY, themeSlice } from "@features/theme";
import { PROFILE_SLICE_KEY, profileSlice } from "@features/profile";
import { SWIPE_SLICE_KEY, swipeSlice } from "@features/mathc";
import {
  EDIT_MODE_SLICE_KEY,
  editModeSlice,
} from "@features/profile/model/editModeSlice";

const reducer = {
  [REDUCER_PATH]: miniAppApi.reducer,
  // [THEME_SLICE_KEY]: themeSlice.reducer,
  [NOTIFICATIONS_SLICE_KEY]: notificationsSlice.reducer,
  [PROFILE_SLICE_KEY]: profileSlice.reducer,
  [SWIPE_SLICE_KEY]: swipeSlice.reducer,
  [EDIT_MODE_SLICE_KEY]: editModeSlice.reducer,
};

const rootReducer = combineReducers(reducer);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(miniAppApi.middleware),
});

export type RootState = StateFromReducersMapObject<typeof reducer>;
export type AppDispatch = typeof store.dispatch;
